import { useMemo } from 'react';

import { ModuleTagging } from '@suntex.fim/framework';
import {
  StarValue,
  StrictNodeModel,
  computeCategoryStarValue,
  computeModuleStarValue,
} from '@suntex.fim/hub';

import { usePlayerProgressSummary } from './usePlayerProgressSummary';

/**
 * Returns a function that computes the {@link StarValue} for any individual module slug.
 * The returned function is stable across renders for the same progress summary.
 */
export function useModuleStarValue(): (
  node: Pick<StrictNodeModel, 'moduleSlug' | 'dataPath' | 'dataTarget'>,
) => StarValue {
  const progressSummary = usePlayerProgressSummary();
  return useMemo(
    () => (node) => computeModuleStarValue(progressSummary, node),
    [progressSummary],
  );
}

/**
 * Returns a function that computes the aggregated {@link StarValue} for a category node.
 * Gold if all descendants are Gold, Silver if all are at least Silver, otherwise None.
 */
export function useCategoryStarValue(
  moduleTagging: readonly ModuleTagging[],
): (categoryNode: StrictNodeModel) => StarValue {
  const progressSummary = usePlayerProgressSummary();
  return useMemo(
    () => (node) =>
      computeCategoryStarValue(progressSummary, node, moduleTagging),
    [progressSummary, moduleTagging],
  );
}
